import { AppCardMedia } from '@app/components/base/app-card';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { FragmentCardMediaOverlay } from '../base/FragmentCardMediaOverlay';
import { PosterVariant } from '../hooks/useFragmentPosterPolling';
import { FragmentCardVideoPosterArea } from './FragmentCardVideoPosterArea';

/**
 * Media area for video fragment: poster image with overlay (time, statuses, duration)
 * and hover thumbnail carousel when fragment.thumbnails is present.
 * Wrapped in AppCardMedia with 16:9 aspect ratio so the media never stretches in compact/small grids.
 */
export function VideoFragmentMedia({
  fragment,
  posterSrc,
  variant,
}: {
  fragment: FragmentListItemDto;
  posterSrc: string | null;
  variant: PosterVariant | null;
}) {
  return (
    <AppCardMedia sx={{ aspectRatio: '16/9', overflow: 'hidden' }}>
      <FragmentCardMediaOverlay fragment={fragment} sx={{ width: '100%', height: '100%' }}>
        <FragmentCardVideoPosterArea fragment={fragment} posterSrc={posterSrc} variant={variant} />
      </FragmentCardMediaOverlay>
    </AppCardMedia>
  );
}
